import React from 'react';
import { Link } from 'react-router-dom';
import { StatusBadge } from '@/components/ui';
import { formatDay, type Transfer } from '../../../services/vehicleTransferService';

/** The orange "pending action" flag on a unit with an open service-area transfer. */
const TransferPendingBanner: React.FC<{ transfer: Transfer }> = ({ transfer: t }) => {
  const waiting =
    t.status === 'APPROVED'
      ? 'all approved, waiting for Finance to apply it in Sage'
      : `${t.approvedCount} of ${t.approvals.length} approvals (waiting on ${t.waitingOn.map((w) => w.approver.name).join(' and ')})`;
  return (
    <div
      role="status"
      className="tw-mb-4 tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3 tw-rounded-lg tw-border tw-border-orange-500 tw-bg-orange-50 tw-px-4 tw-py-3 tw-text-sm tw-text-orange-900"
    >
      <span className="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
        <StatusBadge status="transfer" variant="orange" label={t.needsMyAction ? 'Needs your action' : 'Transfer pending'} />
        <span>
          Transfer to <strong>{t.to.label}</strong> on {formatDay(t.effectiveDate)}: {waiting}. The unit stays in {t.from.label} until Finance
          completes it.
        </span>
      </span>
      <Link to={`/equipment/transfers/${t.id}`} className="tw-font-medium tw-text-orange-900">
        Open transfer #{t.id}
      </Link>
    </div>
  );
};

export default TransferPendingBanner;
